module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "box1"
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Elucidator,” Jordan babbled, as JB’s fingers dug into his arm. “Charles Lindbergh. Time travel. And . . . there are bunk beds in my room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bunk beds? Really?” Katherine said, coming into the dining room behind JB. The others were right behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Haven’t our sons always had bunk beds?” Dad asked. But he was squinting like he really just wanted someone to agree with him, to talk him into the notion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did the time agency put them there, or did it just happen?” Angela asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is my room his room now too?” Jonah asked. His tone was the opposite of Dad’s: He seemed to want someone to tell him no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we all please just stop talking about beds and rooms and—” JB seemed to be making a visible effort not "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("to explode completely. He kept a firm grip on Jordan’s arm and began angling him back toward the stairs. “I know this is a difficult time for you, Jordan, but remember, you’re sick. You’re going to go back to sleep, and later you’ll just remember that you were delirious, and—”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t do that to my son,” Mom said. She stepped forward and jerked JB’s hand away from Jordan’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Whoa, Mom,")]), _vm._v(" Jordan thought. She looked like a middle-school cheerleader—especially since she was wearing a baby-blue sweatshirt of Katherine’s that said "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHEER")]), _vm._v("! in sparkly letters. But she sounded "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("fierce")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom crossed her arms and faced JB directly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You may think you’re in charge here, because you’re the only one who’s an adult right now, and you know more about time travel than the rest of us,” Mom said. “But this is still our house—my, uh, husband’s and mine—and there are house rules. It’s not fair for you to lie to Jordan like that and make him think he’s just imagining things. I won’t allow it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kid version of Dad stumbled over beside Mom and clumsily crossed his arms too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” he agreed. “What she said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody messes with the Skidmore family,” Katherine said, giggling. She sidled up alongside Dad and Mom. “And Jordan probably already heard so much that you might as well tell him everything. And the rest of us too.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Jordan locked eyes with Jonah, who was still standing on the other side of the dining room table.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("See, this is my family. Not yours,")]), _vm._v(" Jordan wanted to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why did he feel mad at Jonah, when JB was the one who’d grabbed him and tried to trick him and send him back to his room?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“JB, maybe some damage just can’t be contained,” the tall girl—Angela?—said softly. “Maybe it’s not even damage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes when your troops complain against you, it’s not because they’re insubordinate,” Chip said. “It’s because you’re wrong.” He leaned close, as if he were some old man imparting wisdom, not just another teenager. “Ruler to ruler, I’ll tell you, sometimes you have to give the people "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("some")]), _vm._v(" of what they’re asking for, lest they seize power for themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was he "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("trying")]), _vm._v(" to sound like some old king from a Shakespeare play or something? And what did he mean by “ruler to ruler”?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("JB let out an exasperated-sounding sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, okay,” he said. “Jordan can come back into the kitchen with us. But there are some questions I’m not answering from anybody.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Everyone trooped back to the kitchen. Jordan noticed that there were five chairs around the kitchen table rather ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("than the usual four—had someone pulled over an extra one just this morning, or was that another bizarre change that happened when the mysterious bunk beds appeared?")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("JB glowered at him, and Jordan decided he should stick to important questions, because there was no telling how long he’d be allowed to stay in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know I was in the dining room?” Jordan asked. “I didn’t make any noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom and Dad looked as puzzled as Jordan felt. Katherine, Jonah, Chip, and Angela exchanged knowing glances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s something you should know about time travel,” Katherine said. “People from the future can see pretty much anything we do. Anytime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s creepy,” Mom said, hunching up her shoulders and shivering. “Why isn’t that illegal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It typically is in connection with the recent past,” JB said in a soothing tone. “But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m confused,” Dad complained, his voice whiny again. “JB wasn’t in the future. He was standing right here with the rest of us. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" didn’t hear Jordan make any noise. How "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("did")]), _vm._v(" JB know he was out of his room?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His Elucidator told him,” Katherine explained. “That thing that looks like a cell phone. He got a message from the future.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Seriously?")]), _vm._v(" Jordan thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Katherine thinks we’re going to fall for that?")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody laughed or even smirked. The other kids all looked grim. JB frowned and put his hand over the pocket in his shirt where he’d evidently put his cell phone. Or his “Elucidator.” Whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we can limit the explanations to only the information that Jordan—and, for that matter, Linda and Michael—absolutely need,” JB muttered, sweeping his hand toward Mom and Dad, lumping them in with Jordan. “They’re not going to travel through time ever again, so they won’t need to know about Elucidators.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it sounds like Elucidators and time travel shaped our lives—and our family,” Mom said in a steely voice. “Don’t we need to know about them to understand our past? What’s the saying? ‘Those who cannot remember the past are condemned to repeat it’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trust Mom, even as a teenager, to come up with something like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("JB stopped beside the island in the middle of the kitchen. Jordan would have preferred to sit down—he still felt a little dizzy—but everyone else seemed too keyed up for that. They all stood around the island, almost as if they were squaring off and choosing sides for an argument.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“You can’t expect the Skidmores not to have questions,” ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Chip said. It sounded like he was trying to be a peacemaker. “I mean, even I’m confused, and I’ve been to other centuries! The separate dimensions with Jonah and Jordan—how did that work? They were both in the same dimension back in the nineteen thirties, right?”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The nineteen thirties?")]), _vm._v(" Jordan thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But once again, everyone else seemed to accept this with absolute calm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("JB sighed and leaned against the island. “Jonah and Jordan, like typical identical twins, were born in the same dimension,” he began. “There "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" only one dimension when they were born, more than eighty years ago. Time split when they were kidnapped from history and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no, no, no, no,” Jordan interrupted, because he couldn’t stand it any longer. “I don’t know about that Jonah kid, but I was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" born more than eighty years ago. I’m thirteen! I’m not like them”—he gestured wildly at the kid versions of Mom and Dad—“I’ve never been any older than this! I’ve never been kidnapped, and I wasn’t ever in ‘history,’ and, and . . . I do "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" have an identical twin!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone looked back and forth between Jonah and Jordan. Jordan didn’t have to be a mind reader or have any of those time-travel Elucidator hocus-pocus skills to be able to tell: Every single person in the room was thinking some variation of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Dude, scream all you want. But you two")]), _vm._v(" are "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("identical")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“I mean, I’m not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("supposed")]), _vm._v(" to have a twin!” Jordan said. “It’s not right! It’s never been this way before!”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("JB looked around at the whole crowd. “And you thought knowing more would make things "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("easier")]), _vm._v(" for him?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is hard no matter what,” Jonah said, and for some reason everyone turned to him respectfully, as though he were some wise person who knew more than anybody else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("he")]), _vm._v(" really is eighty-some years old, and he got turned back into a kid, just like Mom and Dad,” Jordan said frantically, trying out a new theory. “But me—I’m thirteen. I was born "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("thirteen")]), _vm._v(" years ago! I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quit embarrassing yourself,” Katherine muttered, digging her elbow into Jordan’s ribs. And this was so much like the normal Katherine, the one he was used to, that Jordan managed to bite down on his lip and keep from screaming anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The two of us are both thirteen, but we were both born more than eighty years ago,” Jonah said, still in that freakishly calm voice. But Jordan thought maybe the other kid wasn’t as calm as he sounded: He wouldn’t quite meet Jordan’s eyes. “The reason you don’t remember the nineteen thirties, Jordan, is because our enemies kidnapped you when you were only a year and a half old. And then they un-aged you and brought you to this time period. They kidnapped me, too. And a bunch of other kids.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Jordan jerked his gaze accusingly toward JB—hadn’t JB said that he’d last seen Jordan when Jordan was only a year and a half old?")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“It wasn’t me!” JB protested. “It was two men named Gary and Hodge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were collecting famous missing children from history, to take far into the future to be adopted by families who would pay them a lot of money,” Angela added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m famous?” Jordan asked incredulously. He turned to his parents and squinted at them in confusion. “And you paid time-traveling "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("kidnappers")]), _vm._v(" to get me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We didn’t know anything about the time travel or the kidnapping until . . .” Mom glanced at the kitchen clock. “Until about an hour ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—this is weird—it’s like I can’t remember exactly how your adoption worked,” Dad said, wrinkling up his nose in a confused squint. “It’s like we went through one procedure with Jordan, and a different procedure with Jonah, but it was all at the same time. . . . Why would we have done the adoptions separately?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because the two of us were in different dimensions, and you remember both of them,” Jonah said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your brain is probably trying to fuse the memories from both dimensions together,” JB said. “It’s only because you’re in the midst of other oddities that you can see the discrepancy.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("He pulled out his phone—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("no, Elucidator,")]), _vm._v(" Jordan corrected himself—and glanced at it anxiously, as if hoping he’d gotten a message, maybe about Dad’s memory. JB grimaced. Did that mean he’d gotten bad news, or just no news at all? Jordan slid a little closer to JB and craned his neck, but he couldn’t see anything on the phone/Elucidator screen.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("JB raised his head and glanced suspiciously toward Jordan. To cover for his spying, Jordan quickly blurted, “Let’s go back to . . . am I famous?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh yeah, that’s right—Jonah, if you went back to the nineteen thirties, did you find out your original identity?” Chip asked curiously. “Yours "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" Jordan’s, I guess, if you’re twins. Are you royalty, like me and Alex and Daniella and Gavin? The secret children of someone famous, like Emily? Or someone who only became famous in the future, like Brendan and Antonio? Or—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("“We’re nobodies,” Jonah said, and for the first time he didn’t sound calm. His voice was tight. “We were just fakes Gary and Hodge used ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("to try to fool people. To fool Charles Lindbergh and to fool the people who wanted to adopt famous kids from history and”—he darted a quick glance at Jordan and then, just as quickly, looked away—“to fool "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me")]), _vm._v(".”")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Somehow he said the last part as though it were Jordan’s fault. Jordan wanted to protest: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I didn’t do anything to try to fool you! I’d never even seen you before this morning! Believe me, I would have been happy never to have met you at all!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But all the kids on the plane were famous!” Chip protested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not me,” Jonah said, his face rigid. “Not Jordan, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What plane?” Jordan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The one that brought you to this time period,” Angela said, picking up the explanation. “Well, it was actually a time-travel device, but it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("looked")]), _vm._v(" like an ordinary plane. Gary and Hodge were trying to escape some time agents who were chasing them, and so they crash-landed the plane in this time period. Thirteen years ago, I mean. I was working at the airport then, and that’s how I got involved. I saw the plane appear out of nowhere, carrying only babies . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stopped and squinted toward JB.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait,” she said. “Now the different dimensions are confusing me, too. Did Jordan’s plane crash-land, too? Or did Gary and Hodge send him here on purpose, just to confuse Jonah and make everything work with Charles Lindbergh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hard to say exactly at this point,” JB said distractedly, glancing down at his phone/Elucidator again. “Everything’s a little muddy right now, until . . . Ugh! Why can’t anyone locate that Lindbergh Elucidator at a moment that a qualified time agent can sneak into, so we can steal it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He slapped his hand against the granite counter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“How about sending someone who isn’t a qualified time agent?” Jonah asked. “If you need that defective Elucidator so you can make Mom and Dad and Angela the right age again, then—”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We would never send anyone except a qualified time agent after that Elucidator,” JB said, with a tight smile that seemed neither happy nor friendly. “So it doesn’t matter whether anyone else could sneak after it or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made time travel sound almost like hide-and-seek or capture the flag or some other spylike game—only with higher stakes and greater consequences. The minute JB’s gaze dropped to his phone/Elucidator again, Jordan saw all the other kids besides Mom and Dad exchanging significant glances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad seemed oblivious. But Mom caught Jordan looking at her and she raised an eyebrow questioningly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Send me to get that Elucidator,” Mom said abruptly, pointing right at the sparkliest "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("E")]), _vm._v(" of the word "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHEER")]), _vm._v("! on her sweatshirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” JB exclaimed, dropping his hand so his phone/Elucidator almost hit the counter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“It makes sense,” Mom said. “I don’t belong in this time period anyhow, as a teenager. So I’m out of place to begin with. And that Elucidator would either be in the nineteen thirties or the far-off future, and I haven’t been in either ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("of those time periods before, so there wouldn’t be any chance that I’d mess up time by being in the same place twice. And this would help my family.”")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked around beseechingly, her gaze lingering on Jordan and Jonah and Katherine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh!” Dad said, as if he were just catching on. “Send me, too!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right, because the two of you have the least amount of time-travel experience of anyone in the room,” JB said scornfully. “Even "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Jordan’s")]), _vm._v(" done more time travel than you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why did he have to use Jordan as the example of someone stupid and inexperienced?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could send me,” Katherine said. “Or Chip or Jonah or Angela. If it’s against time-agency regulations, you could do what you did when we were dealing with 1918 and you kind of accidentally on purpose set your Elucidator for voice commands. How were you supposed to know that some eleven-year-old girl like me would grab the Elucidator and zip off to the past in front of a bunch of assassins?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Did Katherine actually do that?")]), _vm._v(" Jordan wondered. His stomach felt queasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because if you tell me to do something ‘accidentally on purpose,’ the time agency would never suspect me of faking a mistake,” JB muttered sarcastically.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Did he mean that he would have tried something like ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("that if Katherine hadn’t just ruined his plan by suggesting it?")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Is the time agency still spying on all of us?")]), _vm._v(" Jordan wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was an awkward silence that reminded Jordan of the school play last year, when one of his friends forgot his lines and none of the other actors knew how to cover for the mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey—Venn diagrams,” Katherine said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What")]), _vm._v(" are you talking about?” Jordan and Jonah both said. And it was horrible how identical their voices sounded, blending together. Their voices even cracked on the same word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine smiled sweetly at both of them, turning her head side to side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I figured out the best way to make sense of the different dimensions,” she said. “It’s like those Venn diagrams they have us draw at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned around and grabbed the pad of paper Mom kept by the phone for messages. Then she rifled through the junk drawer for a pen. While everyone watched, she put the paper down flat on the island and drew two interlocking circles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, these are the two separate dimensions Jonah and Jordan were in,” she said. “Everybody except the kids who came from the past lived in both dimensions, and remembers things from both dimensions.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("In the center, where the circles overlapped, she wrote, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Just about everybody.")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0042-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see where you’re going with this, but there should really be three circles,” Jonah said. “Because there was a third dimension too, where no kids from the past ended up in this time period. So I guess you got to be an only child there, Katherine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grabbed the pen and drew a third interlocking circle around the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Just about everybody.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0042-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan expected Katherine to yell and grab the pen back, but she didn’t. She just tilted her head to the side and said, “I did? Shouldn’t I remember that, too?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Is that what I saw in that one moment when my room looked like Mom’s personal home office?")]), _vm._v(" Jordan wondered uncomfortably. ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Some dimension where Katherine was the only Skidmore kid?")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s easier for time to overwrite an absence than a presence,” JB said distractedly. He was looking at his phone/Elucidator, not Katherine’s drawing. “So it makes sense that you’ve already forgotten that dimension. It’s harder to forget either Jordan or Jonah when they’re standing right in front of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Too bad for you, Katherine,” Jordan blurted, because this whole topic was making him feel weirder than ever. Teasing Katherine, at least, was normal. “I bet you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("loved")]), _vm._v(" being an only child. Having all the attention to yourself . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine kept her headed tilted thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she said. “I think I do kind of remember. I was . . . lonely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still don’t understand, and that diagram doesn’t help at all,” Dad complained. “It looks like all the dimensions are the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s because I’m not finished,” Katherine said. “Watch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took the pen back and wrote "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Nobody extra from the past")]), _vm._v(" in the open space of the circle Jonah had drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Then she pointed to one of the other circles.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“In this dimension,” she said, “Jonah, Chip, and the other thirty-four kids who came off the plane from the past remember only their own dimension.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wrote, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Jonah, Chip, other kids from plane,")]), _vm._v(" in the part of the first circle that didn’t overlap with anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0044-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan still wasn’t ready to believe the story about any kids coming from the past—or, for that matter, about extra dimensions of time—but he saw Chip, Jonah, and Angela nod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And this is Jordan’s dimension,” Katherine said, pointing at the third circle and writing "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Jordan")]), _vm._v(" in the only open space left that didn’t overlap with any other circle.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0044-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Then she put the pen down.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait—you’re saying I’m the only person in that category?” Jordan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” Jonah agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But why? Weren’t there other kids on the plane in my dimension too?” Jordan asked. And it was ridiculous how hard he had to work to keep the panic out of his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In your dimension, you were the only baby taken off the plane thirteen years ago,” Jonah said. “All the other babies in your dimension stayed on the plane and—well, then it gets complicated. All you need to know is that you’re the only person who remembers only your dimension and nothing else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he spoke, Jonah stayed on the other side of Katherine, his hands flat on the island counter. But Jordan felt as though Jonah had punched him. Jordan had as much trouble pulling air into his lungs as if he’d gotten a solid jab in the gut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then . . . I’m all alone?” Jordan asked, and this time he couldn’t disguise how forlorn he felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course not, honey,” Mom said, circling the island to pat his back. She pointed at Katherine’s drawing. “Remember that ‘just about everybody’ is in your dimension, too. You’re not alone at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somehow it wasn’t very comforting to have Mom pat his back when she looked like she was the same age as him. It was just weird.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("“And anyhow, those circles just show what happened in the past, what we lived through before the three dimensions merged,” Chip said. He seemed to be trying for a soothing, conciliatory tone. But he ruined it by adding admiringly, “Right, Jonah? We’re all in the same circle now. That’s how you saved time, isn’t it?”")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Chip touched Katherine’s drawing and then squeezed his fingers together, as if to show the three circles coming together into one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan also squeezed his fingers together. Into fists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But before he could say or do anything else, JB started shaking his phone/Elucidator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could the Elucidator malfunction at a time like this?” he said disgustedly. “Hadley, listen, I’m not getting your transmission. I’m going to have to put this on voice commands and reset. Hold on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Voice commands!")]), _vm._v(" Jordan thought. Wasn’t that what Katherine had said JB had set his Elucidator on when he’d wanted her to grab it and go to the past? Even though he’d said it wasn’t allowed, was he setting up a way for Katherine or Jonah or Chip to go to the future and snatch the Lindbergh Elucidator and fix everything?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan glanced around at Katherine, Jonah, and Chip. All of them were watching JB run his fingers across the phone/Elucidator’s screen.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“Okay, now try to retransmit,” JB said, holding the phone/Elucidator in front of his mouth.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine rose up on her tiptoes. If she stretched out her arm, would she be able to grab the phone/Elucidator out of JB’s hands?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jonah leaned in. He was farther away, but his arms were longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chip was on the other side of the island from JB. He’d have to dive across the countertop to get his hands on the phone/Elucidator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Whoever grabs JB’s Elucidator and goes to the future and fixes things for Mom and Dad will be the biggest hero of all,")]), _vm._v(" Jordan thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He or she will be alone in a good way.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("And")]), _vm._v(" I’m "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("the one who’s standing closest.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan reached out and snatched the phone/Elucidator from JB’s hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take me to the future!” he screamed. “Take me where I can get that Elucidator we need to help Mom and Dad!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 72
// module chunks = 0